<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto d-flex gap-2">
          <h2 class="mb-0">Freight Quote List</h2>
          <div class="lds-ring inline me-auto ms-2" *ngIf="false">
            <jni-spinner></jni-spinner>
          </div>
        </span>

        <span>
          <p-button label="Create New" (onClick)="redirectToQuotation('')" />
        </span>
      </span>

      <div class="col-12">
        <p-table
          [value]="FreightChargesLists"
          #dt
          responsiveLayout="scroll"
          styleClass="p-datatable-customers"
          [rowHover]="true"
          [rows]="50"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [resizableColumns]="true"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="true"
          (onLazyLoad)="getFreightQuoteList($event)"
          [lazy]="true"
          [totalRecords]="totalRecords"
          styleClass="table-listing">
          <!-- <ng-template pTemplate="caption">
            <div class="d-flex align-items-center">
              <ng-container> </ng-container>
            </div>
          </ng-template> -->
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th style="width: 6rem">Quote #</th>
              <th>Name</th>
              <th>Created By</th>
              <th>Date</th>
              <th>Order #</th>
              <th>Total</th>
              <th>PDF Date</th>
              <th>Last Revised</th>
            </tr>
            <tr>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="quoteId"
                    id="quoteId"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'Id', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="name"
                    id="name"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'Name', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="createdBy"
                    id="createdBy"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'createdby',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="createdDate"
                    id="createdDate"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'createddate',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="orderNumber"
                    id="orderNumber"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'salesOrderIdD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="number"
                    name="total"
                    id="total"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'total', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>

              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="createdDate"
                    id="createdDate"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'modifieddate',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="modifiedDate"
                    id="modifiedDate"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'modifieddate',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-FreightChargesList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="FreightChargesList"
              [pSelectableRowIndex]="rowIndex">
              <td>
                <a
                  class="link"
                  (click)="redirectToQuotation(FreightChargesList.quoteId)">
                  {{ FreightChargesList.quoteId }}
                </a>
              </td>
              <td>{{ FreightChargesList.name }}</td>
              <td>{{ FreightChargesList.createdBy }}</td>
              <td>{{ FreightChargesList.createdDate | date: "MM-dd-yyyy" }}</td>
              <td>{{ FreightChargesList.salesOrderIdD365 }}</td>
              <td>
                <span *ngIf="FreightChargesList.total > 0">
                  $ {{ FreightChargesList.total | number: "1.2-2" }}
                </span>
              </td>
              <td>
                <a
                  href="javascript:;"
                  (click)="downloadPdf(FreightChargesList.quoteId)"
                  *ngIf="FreightChargesList.document; else noPdf">
                  {{ FreightChargesList.createdDate | date: "MM-dd-yyyy" }}
                </a>
                <ng-template #noPdf>
                  {{ FreightChargesList.createdDate | date: "MM-dd-yyyy" }}
                </ng-template>
              </td>
              <td>
                {{ FreightChargesList.modifiedDate | date: "MM-dd-yyyy" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="30">No Data Found.</td>
            </tr>
          </ng-template>
          <!-- <ng-template pTemplate="footer">
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </ng-template> -->
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="quotationDisplayModal"
  [displayModal]="quotationDisplayModal"
  (closeEvent)="closeModalForQuotation()">
  <h1 class="panelHeading">Freight Quotation</h1>
  <div class="panelBody">
    <jni-freight-quotation-form
      [quoteId]="quoteId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (formChanged)="onFreightFormChanged($event)"
      (closeModalEvent)="closeModalForQuotation()"></jni-freight-quotation-form>
  </div>
</jni-modal-stacker>

<p-dialog
  header="Quote Summary"
  [(visible)]="pdfViewerPage"
  position="center"
  [modal]="true"
  [style]="{ width: '100vw', height: '100vw' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  (onHide)="closeModalPdfViewerPage()">
  <ngx-extended-pdf-viewer
    [base64Src]="base64Pdf"
    [textLayer]="true"
    [showHandToolButton]="true"
    [showPresentationModeButton]="true"
    [filenameForDownload]="fileNameToDownload">
  </ngx-extended-pdf-viewer>
</p-dialog>

<jni-confirm-dialog
  [dialogMessage]="addressClearMessage"
  dialogHeading="Pending changes"
  *ngIf="clearAlertVisible"
  [hideIcon]="true"
  (confirmDialogStatus)="confirmCloseModalForQuotation($event)">
</jni-confirm-dialog>
